(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const markMediaState = (media) => {
    if (media.querySelector('.tis-product-image-slot')) return;
    const images = media.querySelectorAll('img');
    if (!images.length) return;

    const primary = images[0];
    const update = () => {
      media.classList.toggle('is-ready', primary.complete && primary.naturalWidth > 0);
    };

    images.forEach((image) => {
      if (!image.complete) {
        image.addEventListener('load', update, { once: true });
        image.addEventListener('error', update, { once: true });
      }
    });
    update();
  };

  const initialize = (root = document) => {
    root.querySelectorAll('[data-tis-media]').forEach(markMediaState);

    root.querySelectorAll('[data-tis-carousel]').forEach((carousel) => {
      if (carousel.dataset.tisReady === 'true') return;
      carousel.dataset.tisReady = 'true';

      const track = carousel.querySelector('[data-tis-carousel-track]');
      const previous = carousel.querySelector('[data-tis-carousel-previous]');
      const next = carousel.querySelector('[data-tis-carousel-next]');
      const progress = carousel.querySelector('[data-tis-carousel-progress]');
      if (!track || !previous || !next || !progress) return;

      const update = () => {
        const maximum = Math.max(track.scrollWidth - track.clientWidth, 0);
        const fraction = maximum ? track.scrollLeft / maximum : 0;
        const visibleFraction = Math.min(track.clientWidth / track.scrollWidth, 1);
        progress.style.width = `${Math.max(visibleFraction * 100, 12)}%`;
        progress.style.transform = `translateX(${fraction * (100 / Math.max(visibleFraction, 0.12) - 100)}%)`;
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft > maximum - 2;
        carousel.classList.toggle('is-static', maximum < 2);
      };

      const move = (direction) => {
        const card = track.querySelector('.tis-home-product') || track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
        track.scrollBy({
          left: distance * direction,
          behavior: reducedMotion.matches ? 'auto' : 'smooth',
        });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(update) : null;
      resizeObserver?.observe(track);
      track.querySelectorAll('img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', update, { once: true });
      });
      window.addEventListener('resize', update, { passive: true });
      const unload = (event) => {
        if (event.target.contains(carousel)) {
          resizeObserver?.disconnect();
          document.removeEventListener('shopify:section:unload', unload);
        }
      };
      document.addEventListener('shopify:section:unload', unload);
      update();
    });

    root.querySelectorAll('[data-tis-home-invite]').forEach((invite) => {
      if (invite.dataset.tisInviteReady === 'true') return;
      invite.dataset.tisInviteReady = 'true';

      let returnFocus = null;
      const close = () => {
        invite.classList.remove('is-open');
        invite.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('tis-home-invite-open');
        returnFocus?.focus?.();
      };
      const open = () => {
        returnFocus = document.activeElement;
        invite.classList.add('is-open');
        invite.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('tis-home-invite-open');
        window.setTimeout(() => {
          const focusTarget = window.matchMedia('(min-width: 700px)').matches
            ? invite.querySelector('input[type="email"]')
            : invite.querySelector('.tis-home-invite__card');
          focusTarget?.focus({ preventScroll: true });
        }, 100);
      };

      invite.querySelectorAll('[data-tis-home-invite-close]').forEach((button) => button.addEventListener('click', close));
      invite.querySelector('[data-tis-home-invite-form]')?.addEventListener('submit', () => window.setTimeout(close, 0));
      invite.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close();
      });

      const timer = window.setTimeout(open, 7000);
      const unload = (event) => {
        if (!event.target.contains(invite)) return;
        window.clearTimeout(timer);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
